import styled from 'styled-components';

/**
 * The page frame every ISP Business screen sits in.
 *
 * Copied from the Piso WiFi dashboard's own wrapper rather than picked by eye —
 * the two products share a shell, and a page that starts 24px higher than its
 * neighbours reads as a bug even when nobody can say why. Ray spotted exactly
 * that on the ISP header (2026-08-28).
 */
export const IspPage = styled.div`
   display: flex;
   flex-direction: column;
   gap: 14px;
   margin-top: 1.5rem;
   margin-bottom: 1rem;
   padding: 0 1rem;

   @media (max-width: 768px) {
      margin-top: 12px;
      padding: 0 12px;
   }
`;
